<template>
  <div style="padding-top:60px;" v-if="wxFalg">
     <div class="top" >
        <img @click="gohome()" :style='mystyle' src="../assets/img2/lo.png" alt="" srcset="">
             <!-- <h3>目录</h3> -->
        <van-button type="default" @click="getLanguage(types)">
            <span >{{nemeType}}</span>
        </van-button>
      </div>
      
      <div class="hello" v-if="datas">
        <div v-if="!NGType" style="font-size: 0.2rem;padding-top: 0.33rem;">
           <span style="font-size: 0.36rem;font-weight:600;border-right: 2px solid #4c4948;color: #4c4948;padding-right: 5px;font-family:Helvetica, Arial, Helvetica, sans-serif;" @click="gohome()">目录</span>
           <span style="color: #4c4948;padding-left: 3px;font-size: 0.3rem; font-weight:600;font-family:Helvetica, Arial, Helvetica, sans-serif;" @click="back()">{{ne}}</span>
        </div>
        <div class="imgw" style="font-size:0.2rem" v-html="datas.notice.content" v-if="!NGType"></div>
        <div class="bnt"  v-if="!NGType">
          <van-button class="bnt1" type="default" v-if="datas.next_page" @click="getnext(datas.next_page.id)" ><img style="height: 0.2rem;" src="../assets/img2/l1.png" alt="" srcset=""></van-button>
          <van-button class="bnt2" type="default" v-if="datas.previous_page" @click="getnext(datas.previous_page.id)"><img style="height: 0.2rem;" src="../assets/img2/r1.png" alt="" srcset=""></van-button>
        </div>
    </div>
    <div class="zanwu" v-if="NGType">
        <h4 style="font-size: 0.4rem;">under construction...</h4>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import $ from 'jquery'
export default {
  name: 'HelloWorld',
  data () {
    return {
      id: '',
      types:'',
      datas:'',
      nemeType:'ENG',
      NGType:false,
      ne:'',
      mystyle:{marginTop: '10px'},
      imgUrl:require("../assets/img2/lo3.jpg"),
      wxFalg:false,
    }
  },
  created() {
      this.id = this.$route.query.id
      this.types = this.$route.query.types
      this.ne = this.$route.query.ne
      console.log(this.id)
      if(this.types == 1){
        this.nemeType = 'ENG'
         this.NGType = false
      }else if (this.types== 2){       
        this.nemeType = '中文'
        this.NGType = true

      }
      this.int()
      this.getData()
     

  },
  methods:{
    int(){
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if(isiOS){
        if(window.localStorage.getItem('wxNum')){
            this.wxFalg = true;
            window.localStorage.clear()
            // console.log(2)
          }else{
            window.localStorage.setItem('wxNum','b')
            window.location.reload()
          // console.log(1)
          }
      }else{
        this.wxFalg = true;
      }
    },
    getnext(id){
      this.id = id;
      //  this.$router.replace() 
      this.$router.replace({path:'/detaill',query: {id:this.id,types:this.types,ne:this.ne}})
      this.getData()
      //this.int()
    },
    getLanguage(type){
        if(this.types == 1){
            this.types = 2;
            this.nemeType = '中文' 
             this.NGType = true
            console.log(this.types+this.nemeType)
        }else if (this.types== 2){
            this.types = 1;
            this.nemeType = 'ENG'
            this.NGType = false
            console.log(this.types+this.nemeType)
             this.getData()
        }
     
    },
    getData(){
         let _this = this
          this.$http({
          methods: 'GET',
          url: '/index.php/App/AjaxPublic/noticedetail?types='+this.types+'&id='+this.id,
        })
        .then(function (res) {
          window.scrollTo(0, 0);
          document.documentElement.scrollTop = document.body.scrollTop = 0;
          // console.log(res.data.data);
          _this.datas = res.data.data;
          console.log( _this.datas)
           _this.initWx()
        })
        .catch(function (error) {
          console.log(error);
        })
    },
    back(){
      this.$router.back(-1)
    },
    gohome(){
      this.$router.push({path:'/home'}) 
    },
    initWx(){
            var _this = this
            var randNumber = Math.floor(Math.random() * 100000 + 1);
            var getWxData = '';
                $.post(this.baseUrl+"/index.php/App/AjaxPublic/getWxData",{"request_url":window.location.href},function(res){
                if(res.code == 1){
                    getWxData = res.data;
                    // console.log(getWxData);
                    wx.config ({  
                        debug : false,    // true:调试时候弹窗  
                        appId : getWxData.appId,  // 微信appid  
                        timestamp : getWxData.timestamp, // 时间戳  
                        nonceStr : getWxData.nonceStr,  // 随机字符串  
                        signature :getWxData.signature, // 签名  
                        jsApiList : [  
                            // 所有要调用的 API 都要加到这个列表中  
                            'onMenuShareTimeline',   // 分享到朋友圈接口  
                            'onMenuShareAppMessage', //  分享到朋友接口  
                            'onMenuShareQQ',         // 分享到QQ接口  
                            'onMenuShareWeibo'       // 分享到微博接口  
                        ]  
                    });  
                    wx.ready (function () {  
                        // 微信分享的数据  
                        var shareData = {  
                            "imgUrl" :"http://project.tsinghua-auto.cn/Public/Xinwen/fenxiang/fenxiang.jpg?v="+randNumber,    // 分享显示的缩略图地址  
                            "link"  : window.location.href,// 分享地址  
                            "desc"  : _this.ne+'-'+_this.datas.notice.title,   // 分享描述  
                            "title" : "成果汇编",   // 分享标题  
                            success : function () {  
                            }   
                        };   
                            wx.onMenuShareTimeline (shareData);   
                            wx.onMenuShareAppMessage (shareData);   
                            wx.onMenuShareQQ (shareData);   
                            wx.onMenuShareWeibo (shareData);  
                    });  
                    
                    wx.error(function(res){   
                        console.log(res);
                        // alert(JSON.stringify(res));
                    });  
                }else{
                }
            },"JSON");  
        }
  },
  mounted(){
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(isiOS){
      this.mystyle.marginTop = '11px'
    }
   
  }
}
</script>

<!--item Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.hello{
  /* text-align: center; */
  padding: 0 14px;
  overflow: hidden;
}

.text{
  padding: 0 15px;
}
.text img{
  width: 100%;
}
.text p{
  /* text-align: left; */
  text-indent: 30px;
}
.bnt{
      margin: 0.6rem 0;
  width: 100%;
  overflow: hidden;
}
.bnt1{
 float: left;
     border: 1px solid #ffffff;
}
.bnt2{
 float:right;
     border: 1px solid #ffffff;
}
.top2{
  background: #fff;
  position: relative;
  border-bottom: 1px solid #e3e3e3; 
}
.top{
    background: #fff;
    position: fixed;
    height: 60px;
    width: 100%;
    border-bottom: 1px solid #e3e3e3;
    text-align: left;
    top: 0;
    left: 0;
    z-index: 10;
}
.top img{
    width: 50%;
    margin-left: 20px;
    height: 38px;
}
</style>
<style>
.imgw img{
  width: 100%!important;
  height: 100%;
}
.imgw p{
  word-wrap: break-word
}
.zanwu{
    margin-top: 47%;
    color: #999;
}
.zanwu h4{
   margin: 0 auto;
   text-align: center
}
</style>


// WEBPACK FOOTER //
// src/components/detaill.vue